import React, { useState } from "react";
import {
  FormLabel,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  RadioGroup,
  Radio,
  InputAdornment,
  IconButton,
  FormControl,
  CircularProgress,
} from "@material-ui/core";
import clsx from "clsx";
import { VisibilityOff, Visibility } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import styles1 from "./styles.less";
import { Autocomplete } from "@material-ui/lab";
import NumberFormat from "react-number-format";
import PasswordStrengthBar from "react-password-strength-bar-sz";
import ExirioStyles from "../../utils/exirioStyles";
const checkStyles = makeStyles({
  text: {
    fontSize: "14px",
  },
  option: {
    width: "100%",
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // backgroundColor:'error'
  },
});

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
}
const FormItem = (props) => {
  //  const redux = useSelector(state => state.theme)
  const useStyles1 = makeStyles({
    root: {
      width: "100%",
      height: "3.5em",
      backgroundColor: "#006DEA",
      marginTop: "5%",
    },
    text: {
      fontSize: "larger",
    },
    radio: {
      display: "flex",
      flexDirection: "row",
      color: "white",
    },
  });
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      // marginTop: '1rem',
      flex: 1,
      textAlign: "center",
    },
    rootPassword: {
      width: "100%",
      flex: 1,
      textAlign: "center",
    },
    rootIconButton: {
      padding: 0,
    },
    input: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: props.backgroundFill
          ? "0 0 0 1000px #0B1229 inset"
          : "0 0 0 1000px #15224C inset",
        WebkitTextFillColor: "#fff",
      },
      "&:-webkit-text-stroke-color": "white",
      width: "100%",
      textAlign: "left",
    },
    strength: {
      width: "100px",
      minHeight: "25px",
    },
    cssOutlinedInput: {
      "&$cssFocused $notchedOutline": {
        borderColor: `yellow !important`,
      },
    },

    focused: {
      "& $notchedOutline": {
        borderColor: `${ExirioStyles.primaryColorMain} !important`,
      },
    },

    notchedOutline: {
      borderWidth: "1px",
      // borderColor: 'error !important'
      borderColor: `${ExirioStyles.background} !important`,
    },
  }));
  const classes = useStyles();
  const buttonClass = useStyles1();
  const checkClass = checkStyles();
  const [values, setValues] = useState({ showPassword: false });
  const handleClickShowPassword = () => {
    setValues(() => ({ showPassword: !values.showPassword }));
  };

  const InputType = () => {
    const {
      inputType,
      id,
      label,
      handleChange,
      selectItems,
      defaultValue,
      className,
      value,
      radioOptions,
      email,
      onChange,
      variant,
      color,
      onClick,
      loading,
      error,
      type,
      margin,
      size,
      required,
      getOptionLabel,
      strength,
      autoComplete,
      disabled,
      isCurrency,
    } = props;

    switch (inputType) {
      case "LOGINBUTTON":
        return (
          <Button
            variant="contained"
            type="submit"
            color="primary"
            classes={{
              root: buttonClass.root, // class name, e.g. `classes-nesting-root-x`
              label: buttonClass.text, // class name, e.g. `classes-nesting-label-x`
            }}
            onClick={onClick}
          >
            {label}
          </Button>
        );
      case "CHECKBOX":
        return (
          <FormControlLabel
            classes={clsx(className, checkClass.text)}
            control={
              <Checkbox
                checked={true}
                onChange={onChange}
                name={label}
                color="primary"
              />
            }
            label={label}
          />
        );
      case "PASSWORD":
        return (
          <>
            <TextField
              onChange={(e) => {
                if (handleChange) {
                  handleChange(e);
                }
              }}
              autoComplete={autoComplete}
              name={id}
              value={value}
              error={error}
              className={clsx(className, classes.rootPassword)}
              InputProps={{
                className: classes.input,
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
                endAdornment: (
                  <InputAdornment>
                    {" "}
                    <IconButton
                      className={clsx(className, classes.rootIconButton)}
                      onClick={handleClickShowPassword}
                    >
                      {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>{" "}
                  </InputAdornment>
                ),
              }}
              type={values.showPassword ? "text" : "password"}
              label={label}
              variant={"outlined"}
              size={size}
              margin={margin}
            />
            {strength && (
              <div className={classes.strength}>
                {value && (
                  <PasswordStrengthBar
                    password={email === value ? "aaaa" : value}
                  />
                )}
              </div>
            )}
          </>
        );
      case "SELECT":
        return (
          <FormControl color="primary" className={className && className}>
            <Autocomplete
              autoComplete={true}
              autoHighlight={true}
              autoSelect={true}
              id={id}
              disabled={disabled}
              value={value}
              options={selectItems}
              disableListWrap={true}
              classes={{
                option: isCurrency ? checkClass.option : "",
                // option: isCurrency?checkClass.option:{}, //creating key error
                // listbox: cs.listbox,
              }}
              closeIcon={false}
              getOptionLabel={
                getOptionLabel ? getOptionLabel : (option) => option.label || ""
              }
              style={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  error={error}
                  required={required}
                  {...params}
                  label={label}
                />
              )}
              onChange={(event, newValue) => {
                if (newValue && (newValue.value || newValue.id))
                  handleChange &&
                    handleChange(null, newValue.value || newValue.id);
              }}
            />
          </FormControl>
        );
      case "RADIO":
        return (
          <div className={className && className}>
            <FormLabel>{label}</FormLabel>
            <RadioGroup
              className={buttonClass.radio}
              aria-label={id}
              name={id}
              value={value || null}
              onChange={onChange}
            >
              {radioOptions.map((opt) => {
                return (
                  <FormControlLabel
                    value={opt.radioValue}
                    control={<Radio style={{ color: "white" }} />}
                    label={opt.label}
                  />
                );
              })}
            </RadioGroup>
          </div>
        );
      case "BUTTON":
        return (
          <Button
            onClick={onClick}
            className={className && className}
            variant={variant}
            disabled={loading}
            color={color && color}
          >
            {" "}
            {loading && (
              <CircularProgress
                size={10}
                style={{ marginRight: "10px", color: "white" }}
              />
            )}{" "}
            {label}
          </Button>
        );
      case "TEXT":
        return <div className={styles1.checkBox}>{label}</div>;
      default:
        return type === "number" ? (
          <TextField
            value={value}
            className={clsx(className, classes.root)}
            name={id}
            onChange={(e) => {
              let val = parseFloat(e.target.value);
              if (isNaN(val)) {
                val = undefined;
              }
              if (handleChange) {
                handleChange(null, val);
              }
            }}
            // variant={variant || ''}
            disabled={disabled}
            error={error}
            defaultValue={defaultValue && defaultValue}
            InputLabelProps={{
              className: classes.input,
            }}
            label={label}
            size={size}
            required={required}
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          />
        ) : (
          <TextField
            value={
              type === "number"
                ? isNaN(parseFloat(value))
                  ? value
                  : parseFloat(value)
                : value
            }
            autoComplete={autoComplete ? autoComplete : "off"}
            name={id}
            type={type}
            className={clsx(className, classes.root)}
            onChange={(e) => {
              e.preventDefault();
              e.persist();
              if (handleChange) {
                handleChange(e);
              }
            }}
            error={error}
            defaultValue={defaultValue && defaultValue}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            disabled={disabled}
            variant="outlined"
            label={label}
            size={size}
            margin={margin}
            required={required}
            autoFocus={props?.autoFocus || false}
          />
        );
    }
  };
  return (
    <FormLabel
      className={clsx(props.labelStyle ? props.labelStyle : classes.root)}
    >
      {InputType()}
    </FormLabel>
  );
};
export default FormItem;
